import React from 'react';
import supportImage from './assets/vision-mission/digital-support.png';
import ourVisionImage from './assets/vision-mission/our-vision.png';

const VisionMissionSection = ({ isArabic }) => {
  const text = {
    en: {
      vision: {
        heading: "OUR VISION",
        title: "To be among the leading entities in developing digital financial solutions",
        description: "Contributing to building a more aware and organized financial environment in Libya and beyond.",
        cta: "Learn more →"
      },
      mission: {
        heading: "OUR MISSION",
        title: "Providing supportive financial services and innovative digital solutions",
        description: "Helping simplify financial concepts, support digital transformation, and build long-term relationships based on trust and credibility.",
        cta: "Discover more →"
      }
    },
    ar: {
      vision: {
        heading: "رؤيتنا",
        title: "أن نكون من الجهات الرائدة في تطوير الحلول المالية الرقمية",
        description: "المساهمة في بناء بيئة مالية أكثر وعيًا وتنظيمًا في ليبيا وما بعدها.",
        cta: "اعرف المزيد ←"
      },
      mission: {
        heading: "رسالتنا",
        title: "تقديم خدمات مالية مساندة وحلول رقمية مبتكرة",
        description: "مساعدة على تبسيط المفاهيم المالية، ودعم التحول الرقمي، وبناء علاقات طويلة الأمد قائمة على الثقة والمصداقية.",
        cta: "اكتشف المزيد ←"
      }
    }
  };

  const currentLang = isArabic ? 'ar' : 'en';

  return (
    <section id="vision" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Vision - Left Column */}
          <div className="p-6 sm:p-8 lg:p-16 flex flex-col justify-between rounded-2xl" style={{backgroundColor: '#E6F5F3'}}>
            {/* Heading */}
            <p className="text-xs sm:text-sm font-semibold tracking-wider uppercase mb-4" style={{color: '#006655'}}>
              {text[currentLang].vision.heading}
            </p>

            {/* Main Text */}
            <div className="mb-6 sm:mb-8">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black leading-tight mb-3 sm:mb-4">
                {text[currentLang].vision.title}
              </h2>
              <p className="text-base sm:text-lg text-gray-700">
                {text[currentLang].vision.description}
              </p>
            </div>

            {/* Vision Image */}
            <div className="flex justify-center mb-6 sm:mb-8">
              <img 
                src={ourVisionImage} 
                alt="Our Vision" 
                className="w-56 h-56 sm:w-72 sm:h-72 lg:w-96 lg:h-96 object-contain"
              />
            </div>

            {/* CTA Button */}
            <button 
              className="w-full lg:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-full text-white font-semibold text-base sm:text-lg transition-all hover:opacity-90 hover:shadow-lg"
              style={{backgroundColor: '#006655'}}
            >
              {text[currentLang].vision.cta}
            </button>
          </div>

          {/* Mission - Right Column */}
          <div className="p-6 sm:p-8 lg:p-16 flex flex-col justify-between bg-gray-50 rounded-2xl">
            {/* Support Image */}
            <div className="flex justify-center mb-6 sm:mb-8">
              <img 
                src={supportImage} 
                alt="Mission - Digital Solutions" 
                className="w-40 h-40 sm:w-48 sm:h-48 lg:w-64 lg:h-64 object-contain"
              />
            </div>

            {/* Heading */}
            <p className="text-xs sm:text-sm font-semibold tracking-wider uppercase mb-4" style={{color: '#006655'}}>
              {text[currentLang].mission.heading}
            </p>

            {/* Main Text */}
            <div className="mb-6 sm:mb-8">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black leading-tight mb-3 sm:mb-4">
                {text[currentLang].mission.title}
              </h2>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                {text[currentLang].mission.description}
              </p>
            </div>

            {/* CTA Link */}
            <a 
              href="#services" 
              className="text-black font-semibold text-base sm:text-lg hover:opacity-70 transition-opacity inline-flex items-center"
            >
              {text[currentLang].mission.cta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionSection;